import React, { Component } from "react";

import Aux from "../../../hoc/ReactAux/ReactAux";
import ReactModal from "react-modal";

const customStyles = {
  content: {
    background: "none",
    border: "none"
  },
  overlay: {
    zIndex: "9999999",
    width: "100%",
    height: "100%",
    left: "0",
    top: "0",
    backgroundColor: "rgba(0, 0, 0, 0.7)"
  }
};

class ModalValidateEmails extends Component {
  render() {
    if (!this.props.showModal) {
      return null;
    }
    return (
      <Aux>
        <ReactModal
          isOpen={this.props.showModal}
          style={customStyles}
          onRequestClose={this.props.closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          contentLabel="Example Modal"
        >
          <div
            style={this.props.style}
            id="lb-error"
            className="lb-geral mfp-bg-login error-popup-block  lb-centralizar singup zoom-anim-dialog"
          >
            <div className="lb-padrao-singup6 mfp-content-login modal-content">
              <button
                type="button"
                onClick={this.props.closeModal}
                style={{ backgroundColor: "var(--lt-color-primary)" }}
                className="bt-close mfp-close lb-fechar fa fa-times"
              />
              <div className="check-mark">
                <img src={require("../../../img/connected.png")} alt="error" />
                <strong>Validate Emails</strong>
              </div>
              <div
                style={this.props.styleContent}
                className="lb-content scrolling"
              >
                <span className="order">
                  <strong>
                  The following emails are not registered, confirm the ones you wish to Create or Remove them with the X button.
                  </strong>
                  <br />
                  {this.props.unregistered.map((email, index) => (
                    <div key={index} className="confirmContainer">
                      <button
                        onClick={() => this.props.filterAction(email)}
                        type="button"
                        className="small"
                      >
                        X
                      </button>
                      <p>{email.value}</p>
                      {/* <button
                        type="button"
                        className="validateButton"
                        onClick={() =>
                          this.props.validateAction(this.props.emailList, email)
                        }
                      >
                        Create User
                      </button> */}
                    </div>
                  ))}
                </span>
                <br />
                {!!this.props.actionButton ? (
                  <a onClick={this.props.actionButton} className="bt">
                    {this.props.actionButtonTitle}
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        </ReactModal>
      </Aux>
    );
  }
}

export default ModalValidateEmails;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalValidateEmails.js